import React, { useState } from "react";
import { Images } from "../Common/Images";
import { useTranslation } from "react-i18next";
import { getFirstname, getLastname } from "../../utils/SecurityService";
import { formatReactString } from "../../utils/CommonUtils";

const COMPANY_THUMBNAIL_BASE_URL = process.env.REACT_APP_COMPANY_THUMBNAIL;

const CreditInfoCard = ({
  userZoneCreditValue,
  //ZoneName,
  userZoneCreditBalance,
  creditBalanceRefillEvery,
  IsThumbnailPresent,
  CompanyId,
  creditPersonName
}) => {

  const { t } = useTranslation();

  const [UserFirstName] = useState(localStorage.getItem("firstname"));
  const [UserLastName] = useState(localStorage.getItem("lastname"));

  const getInitials = (name) => {
    const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "";
    const first = parts[0][0] || "";
    const last = parts.length > 1 ? parts[parts.length - 1][0] || "" : "";
    return `${first}${last}`.toUpperCase();
  };

  const logoUrl = `${COMPANY_THUMBNAIL_BASE_URL}/${CompanyId}/logo.png`;
  let creditInfoTitle = formatReactString(t("react_the_credit_balance_reset"), [creditBalanceRefillEvery], {
    defaultRenderer: (val, type, index) => (
      <button key={`credit-refill-${index}`}>{val}</button>
    )
  });
  const refillValue = String(creditBalanceRefillEvery || "").trim().toLowerCase();
  const noneValue = String(t("none") || "").trim().toLowerCase();
  const shouldShowCreditInfoTitle =
    refillValue !== "" &&
    refillValue !== noneValue;
  const displayName = String(creditPersonName || "").trim() || `${getFirstname()} ${getLastname()}`;
  return (
    <div className="credit-info">

      {Number(userZoneCreditValue) !== 0 && (
        <button type="button" className="orange-outline-with-icon flex-column">
          <img src={Images.OrangeStar} alt="" />
          <span className="d-block">
            <span>{userZoneCreditBalance}</span>
          </span>
        </button>
      )}

      <div className="credit-info-inner text-center">

        <div className="profile-info-inner">

          <div className="profile-img">
            {IsThumbnailPresent === 1 ? (
              <img
                src={logoUrl}
                alt="Company Logo"
                className="img-fluid"
                onError={(e) => (e.target.style.display = "none")}
              />
            ) : (
              <h5>{getInitials(displayName)}</h5>
            )}
          </div>

          <div className="profile-name">
            {/* <h5>{UserFirstName} {UserLastName}</h5> */}
            {/* <h5>{localStorage.getItem("firstname")} {localStorage.getItem("lastname")}</h5> */}
            <h5>{displayName}</h5>
          </div>

          {/* <div className="profile-location d-flex justify-content-center align-items-center">
            <img src={Images.ProfileLocation} alt="" />
            <p>{ZoneName}</p>
          </div> */}

        </div>

        <div className="credit-balance-info">

          <div className="credit-balance d-flex justify-content-between align-items-center">
            <p>{t("credit_balance")}</p>
            <h6>{userZoneCreditBalance}</h6>
          </div>

          {shouldShowCreditInfoTitle && (
            <div className="credit-balance-btn">
              {creditInfoTitle}
            </div>
          )}

        </div>

        <div className="credit-details-lists">

          <div className="list-card">
            <img src={Images.FillStar} alt="" className="img-fluid" />
            <p>{t("react_use_credits_to_book_spaces")}</p>
          </div>

          <div className="list-card">
            <img src={Images.GrayStar} alt="" className="img-fluid" />
            <p>{t("react_same_day_no_credits_needed")}</p>
          </div>

          <div className="list-card">
            <img src={Images.BlackClose} alt="" className="img-fluid" />
            <p>{t("react_release_booking_for_refund")}</p>
          </div>

        </div>

      </div>
    </div>
  );
};

export default CreditInfoCard;
